/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {SpoDetailService} from '../../../api/ms-specialorders/specialorder/spo-detail.service';
import {Observable} from 'rxjs';
import {SpecialOrderDetailModel} from '../../../api/ms-specialorders/contracts/special-order-detail.model';
import {LoadingService} from '../../../shared/loading/loading-service/loading.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {map, finalize} from 'rxjs/operators';
import {ConfirmModalComponent} from '../../../shared/confirm-modal/deprecated-modals/confirm-modal.component';
import {AlertNotificationSeverity} from '../../../alert-notification-severity.model';
import {ConfirmModal} from '../../../shared/confirm-modal/deprecated-modals/confirm-modal.model';
import {AvailableActions} from '../../../api/ms-specialorders/contracts/available-actions.enum';

@Injectable({
    providedIn: 'root'
})
export class SpoEditGuardResolverService  {

    constructor(private spoDetailService: SpoDetailService,
                private loadingService: LoadingService,
                private router: Router,
                private modalService: NgbModal) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<SpecialOrderDetailModel | null> {
        this.loadingService.start();
        const spoNumber = route.params['sponumber'];

        return this.spoDetailService.getSpecialOrderDetail(spoNumber).pipe(
            map(spo => {
                if (spo.availableActions != null && (spo.availableActions.some(action =>
                        action === AvailableActions.EDIT_POSITION_DELETE ||
                        action === AvailableActions.EDIT_POSITION_CANCEL ||
                        action === AvailableActions.EDIT))) {
                    return spo;
                } else {
                    this.router.navigate(['/', 'spo', spoNumber]);
                    this.notFoundModal();
                    return null;
                }
            }),
            finalize(() => this.loadingService.stop())
        );
    }

    notFoundModal(): void {
        const confirmModalInstance: ConfirmModalComponent = this.modalService.open(ConfirmModalComponent, {
            centered: true
        }).componentInstance;
        confirmModalInstance.initModal({
            titleText: 'Error',
            subtitleText: `Page not found`,
            alertNotificationSeverity: AlertNotificationSeverity.ERROR,
            secondaryButtonText: 'Close'
        } as ConfirmModal);
    }
}
